import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import {
  fetchAdminChatTrace,
  type AdminChatTraceResponse,
} from '@/admin/features/chat-analytics/api';
import { TraceExplorer } from '../components/trace/trace-explorer';

const DETAIL_LIMIT = 1000;

export function ChatDetailPage() {
  const { sessionId = '' } = useParams();
  const [searchParams] = useSearchParams();
  const tenantID = searchParams.get('tenant_id') || undefined;
  const agentID = searchParams.get('agent_id') || undefined;
  const userID = searchParams.get('user_id') || undefined;

  const identityKey = [
    sessionId,
    tenantID || '',
    agentID || '',
    userID || '',
  ].join(':');

  const loadTrace = React.useCallback(
    (requestID?: string): Promise<AdminChatTraceResponse> => {
      if (!sessionId) {
        return Promise.resolve(emptyTrace());
      }
      return fetchAdminChatTrace(sessionId, {
        tenant_id: tenantID,
        agent_id: agentID,
        user_id: userID,
        request_id: requestID,
        limit: DETAIL_LIMIT,
      });
    },
    [agentID, sessionId, tenantID, userID]
  );

  return (
    <div className="flex flex-1 flex-col gap-4 overflow-auto py-4 lg:py-6">
      <TraceExplorer
        identityKey={identityKey}
        loadTrace={loadTrace}
        conversationLink
      />
    </div>
  );
}

function emptyTrace(): AdminChatTraceResponse {
  return {
    header: {
      tenant_id: '',
      agent_id: '',
      session_id: '',
      status: '',
      activity_status: '',
      created_at: '',
      last_activity_at: '',
      message_count: 0,
      tool_call_count: 0,
      token_total: 0,
    },
    requests: [],
    events: [],
    performance: {
      timing: { quality: 'missing' },
      tool_cost: {
        calls: 0,
        errors: 0,
        timeouts: 0,
        canceled: 0,
        input_tokens: 0,
        output_tokens: 0,
        retry: { kind: 'unknown' },
      },
      slow_spans: [],
    },
    diagnostics: [],
    raw: { resolved_payload: false },
    quality: { overall: 'missing' },
  };
}
